
<template>
<div>
  <multiselect v-model="mutableSelectedFormat" :show-labels="false" placeholder="Format auswählen" :options="allformats" :multiple="false"  track-by="id" label="name" :close-on-select="true"></multiselect>
  <b-button class="button is-small is-white" @click="addF">
    <b-icon custom-size="mdi-18px" type="is-black" icon="plus-circle"></b-icon>
    <span style="position: relative;left: 2px;top: -2px;">Neues Format anlegen</span>
  </b-button>

  <b-modal :active.sync="createFormat" has-modal-card>
     <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
              <p class="modal-card-title">Format hinzufügen</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Name">
          <b-input  maxlength="255" v-model="newFormat.name"></b-input>
        </b-field>
        <b-field label="Beschreibung">
          <b-input  maxlength="255" v-model="newFormat.description" type="textarea"></b-input>
        </b-field>
        <b-field label="Bild">
          <b-input  maxlength="255" v-model="newFormat.image"></b-input>
        </b-field>
        <b-field label="Code">
          <b-input  maxlength="255" v-model="newFormat.code"></b-input>
        </b-field>


              {{newFormat}}
      </section>

      <footer class="modal-card-foot">
              <b-button class="button is-primary" @click="addFormat">Übernehmen</b-button>
      </footer>
    </div>
  </b-modal>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
const axios = require('axios');

    export default {
      props: ['selectedformat'],
      components: {
      	Multiselect
    	},
        data(){
          return {
            allformats: [],
            categories: [],
            createFormat: false,
            mutableSelectedFormat: this.selectedformat,
            newFormat: {
              name: "",
              description: "",
              image: "",
              code: ""
            }
          }
        },
        watch: {
          selectedformat(val) {
              this.mutableSelectedFormat = val;
          },
          mutableSelectedFormat(val) {
            console.log("CHANEE");
            this.$emit('input', val);
          }
        },
        mounted() {
          console.log('Component mounted3.');
          //Get Format
          this.getFormats();

        },
        methods: {
          addF: function() { //Popop öffnen und
            this.createFormat = true;
          },
          addFormat: function() { //Ajax-Call zum Speichern
            if ((this.newFormat.name) && (this.newFormat.description)  && (this.newFormat.image) && (this.newFormat.code)){
              console.log(this.newFormat);
              this.allformats.push(this.newFormat);
              this.mutableSelectedFormat = this.newFormat;
              this.createFormat = false;
            } else {
              console.log("err");
              this.$buefy.dialog.alert({
                            title: 'Fehler',
                            message: 'Bitte alle Felder ausfüllen.',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            iconPack: 'mdi'
                        });
            }
      		},

          getFormats: function() {
            var _this = this;
            axios.get('/api/formats', {
              withCredentials: true,
            })
            .then(function (response) {
              console.log(response.data);
              _this.allformats = response.data;
              //_this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
              //  _this.loading = false;
            })
            .then(function () {
              // always executed
            });
          }
        },
      }

</script>
